import { isPolygonOrMultiPolygon } from "../../geometry_utilities";
import { Feature, MultiPolygon, Polygon } from "@turf/turf";

export type SiteMVTFeature = Feature<
  Polygon | MultiPolygon,
  {
    id: string;
    stage: string;
    shared: boolean;
    layerName: "sites";
  }
>;

export function isSiteBoundary(feature: any): feature is SiteMVTFeature {
  const hasValidGeometry = isPolygonOrMultiPolygon(feature?.geometry);
  const hasValidProperties = feature?.properties?.id && feature?.properties?.layerName === "sites";

  return hasValidGeometry && hasValidProperties;
}
